import { render, staticRenderFns } from "./vehicleBindWX.vue?vue&type=template&id=6c24e0ae&scoped=true"
import script from "./vehicleBindWX.vue?vue&type=script&lang=js"
export * from "./vehicleBindWX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24e0ae",
  null
  
)

export default component.exports